



















import { Page, Pageable } from '@/models'
import type { CanaldeVendas } from '@/models'
import { FindCanalDeVendasUseCase } from '@/usecases'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import axios, { CancelTokenSource } from 'axios'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'

@Component
export default class SeletorDeCanalDeVendas extends Vue {
	@Prop({ type: String }) idCanalDeVendasSalvo!: string | null

	canaisDeVendas: CanaldeVendas[] = []
	busca = ''
	pagina: Page<CanaldeVendas> | null = null
	cancelToken: CancelTokenSource | null = null
	findCanalDeVendasUseCase = new FindCanalDeVendasUseCase()
	carregando = true
	canaisDeVendasCarregados = 0
	carregouTodosOsCanaisDeVendas = false

	pageable: Pageable = {
		page: 0,
		size: 5,
		sort: [],
	}

	async created() {
		this.carregando = true
		if (this.idCanalDeVendasSalvo) {
			this.canaisDeVendas.push(await this.findCanalDeVendasUseCase.findById(this.idCanalDeVendasSalvo))
			return
		}
		await this.buscar()
		this.carregando = false
	}

	async buscar() {
		this.carregando = true
		if (this.cancelToken) this.cancelToken.cancel()
		try {
			if (this.idCanalDeVendasSalvo) {
				this.canaisDeVendas.push(await this.findCanalDeVendasUseCase.findById(this.idCanalDeVendasSalvo))
			}
			this.cancelToken = axios.CancelToken.source()
			this.pagina = await this.findCanalDeVendasUseCase.findAll({
				busca: this.busca,
				pageable: this.pageable,
			}, {
				cancelToken: this.cancelToken.token,
			})
			this.pagina.content.forEach(canalDevendas => {
				this.canaisDeVendas.push(canalDevendas)
			})
			this.carregouTodosOsCanaisDeVendas = this.pagina.last || (this.pageable?.size ? this.pagina.content.length < this.pageable.size : true)
		} catch (error: any) {
			if (axios.isCancel(error)) return
			this.pagina = null
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}

		return this.canaisDeVendas
	}

	async pageNext() {
		this.pageable.page = !this.pageable.page
			? 1
			: this.pageable.page += 1
		await this.buscar()
	}

	@Watch('busca', { deep: true, immediate: true })
	onChangeBusca(busca: string, buscaAnterior: string) {
		this.pageable = {
			...this.pageable,
			page: 0,
		}
		if (!buscaAnterior || busca === buscaAnterior) {
			this.carregando = false
			return
		}
		this.canaisDeVendas = []
		this.canaisDeVendasCarregados = 0
		this.buscar()
	}

	get noDataMessage() {
		if (this.carregando) {
			return 'Carregando...'
		}
		if (!this.canaisDeVendas.length) {
			return 'Nenhum resultado encontrado...'
		}
		if (!this.busca) {
			return 'Digite para consultar...'
		}
		return '$vuetify.noDataText'
	}

	@Watch('lojas')
	onchangeLojaId() {
		this.pageable = {
			...this.pageable,
			page: 0,
		}
		this.canaisDeVendas = []
		this.canaisDeVendasCarregados = 0
		this.buscar()
	}
}

